<template>
  <div class="addPerson__wrap" v-if="visible" style="z-index:9999 !important;">
    <el-header class="page-header__wrap">
      <div class="title">
        {{ $route.matched[0].meta.title }}
        <span v-if="$route.matched[0].meta.title"> > </span>
        {{ $route.meta.title }}
        <span>></span>
        预览文件
      </div>

      <div style="display: flex;align-items: center;">
        <div class="pp" @click="handlePrint" v-show="fileType == 2 || fileType == 6">
          <img class="pimg" src="@/assets/img/print.png" alt="" />打印
        </div>
        <el-button type="danger" plian size="mini" plain @click="toggle(false)" icon="el-icon-close">关闭</el-button>
      </div>
    </el-header>

    <div class="page-main__wrap" >
      <div style="flex: 1;margin:20px;display:flex;">
        <vue-office-excel
          v-show="fileType == 5"
          :src="fileUrl"
          :options="options"
          style="width:100%;height: 100%;"
          @rendered="renderedHandler"
          @error="errorHandler"
        />

        <vue-office-docx ref='vueofficedocx'
          v-show="fileType == 2"
          :src="fileUrl"
          class="officeDocx"
          style="width:100%;flex:1;"
          @rendered="renderedHandler"
          @error="errorHandler"
        />

        <cafe-ofd v-show="fileType == 6" style="width:100%;height: 100%;" id="cafeOfdid" ref="cafeOfd" :filePath="fileUrl" > </cafe-ofd>
      </div>
    </div>

    <div id="myPrintMain" v-html="convertedContent" v-if="isOpen"></div>

  </div>
</template>
<script>
//引入VueOfficeExcel组件
import VueOfficeExcel from '@vue-office/excel'
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '@vue-office/excel/lib/index.css'
import '@vue-office/docx/lib/index.css'
import { printContent } from '@/util/usePrint'
export default {
  name: 'fileView',
  components: {
    VueOfficeExcel,
    VueOfficeDocx,
  },
  props:{
    fileUrl: { required: false, type: String, default: "" }, //设置文档地址
    fileType: { required: false, type: Number, default:0 },
    fileName: { required: false, type: String, default: "" },

    // excel: 'http://static.shanhuxueyuan.com/demo/excel.xlsx'//设置文档地址
  },
  data() {
    return {
      visible: false,
      renderSuccess: false,
      errorTimer: null,
      options:{
        xls: true,       //预览xlsx文件设为false；预览xls文件设为true
        minColLength: 0,  // excel最少渲染多少列，如果想实现xlsx文件内容有几列，就渲染几列，可以将此值设置为0.
        minRowLength: 0,  // excel最少渲染多少行，如果想实现根据xlsx实际函数渲染，可以将此值设置为0.
        widthOffset: 10,  //如果渲染出来的结果感觉单元格宽度不够，可以在默认渲染的列表宽度上再加 Npx宽
        heightOffset: 10, //在默认渲染的列表高度上再加 Npx高
        beforeTransformData: (workbookData) => {
          // 清理异常的 sheet，防止因空 sheet 或特殊内容导致渲染崩溃
          if (workbookData && workbookData.sheets) {
            workbookData.sheets = workbookData.sheets.filter(sheet => {
              // 保留至少有一个单元格数据的 sheet
              if (!sheet.data || sheet.data.length === 0) return false;
              // 保留有实际行列的 sheet
              if (sheet.rowCount <= 0 && sheet.colCount <= 0) return false;
              return true;
            });
          }
          return workbookData;
        },
        transformData: (workbookData) => {
          // 二次过滤：移除处理后没有 table 对象的异常 sheet，防止 render 崩溃
          if (workbookData && workbookData.sheets) {
            workbookData.sheets = workbookData.sheets.filter(sheet => {
              return sheet && sheet.table;
            });
          }
          return workbookData;
        },
      },
      convertedContent: '',
      isOpen: false,
    }
  },
 
  methods: {
    getDetail(row) {
      this.options.xls = row.name.substr(row.name.lastIndexOf(".")) == '.xlsx' ? false : true;
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      this.isOpen = false;
      this.renderSuccess = false;
      clearTimeout(this.errorTimer);
      !show && this.reset();
    },
    renderedHandler() {
      console.log("渲染完成")
      this.renderSuccess = true;
      clearTimeout(this.errorTimer);
      this.isOpen = true;
      this.convertedContent = this.$refs.vueofficedocx.$el.innerHTML;
    },
    errorHandler(err) {
      console.log("渲染遇到问题", err);
      // vue-office 在正常渲染过程中可能触发非致命警告，延迟判断是否真正失败
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(() => {
        if (!this.renderSuccess) {
          this.$message.error("文件预览失败，该文件可能存在不兼容的内容格式，请尝试下载后查看");
        }
      }, 1000);
    },
    handlePrint() {
      if(this.fileType == 6) {
        printContent('ofd-61')
      } else {
        printContent('myPrintMain')
      }
    },
  }
}
</script>
<style scoped lang="scss">
@import "~@/assets/scss/index.scss";
.addPerson__wrap {
  // @include position($t: 0, $r: 0, $b: 0, $l: 0);
  background-color: #F2F5FC;
  z-index: 5 !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position:fixed !important;
  top:0;
  right:0;
  bottom:0;
  left:0;
}
.page-header__wrap {
  height: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #595959;
}
.page-main__wrap {
  background: #fff;
  margin: 20px;
  border-radius: 10px;
  margin-top: 0 !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.officeDocx {
  height: calc(100vh - 100px)
}

.pp {
  font-size: 12px;
  color: #646b75;
  margin: 0 30px 0 0;
  cursor: pointer;
  font-weight: 500;
}
.pimg {
  width: 16px;
  height: 16px;
  margin: 0 5px 0 0;
}

@media print {
  body * {
    visibility: visible !important;
  }
  #print-area {
    width: 100% !important;
    margin: 0 !important;
  }
  .el-table__body {  /* 兼容Element UI等框架 */
    color: #000 !important;
  }
  .ofd-item {
    margin:0 !important;
  }
  #ofd-61 {
    margin:0 !important;
  }

}
p.docx_46 {
  margin-bottom: 7.80pt;
  text-indent: 0.00pt;
  text-align: center;
  margin-top: 7.80pt;
}

</style>